import { render } from "./aboutUS.vue?vue&type=template&id=b08f099c"
import script from "./aboutUS.vue?vue&type=script&lang=js"
export * from "./aboutUS.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/omidnoorani-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__